import React from "react";
import "../styles/AccountOverviewCard.css";
import { formatDate } from "../utils/formatDate";

function DownloadIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}

function AccountOverviewCard({ accountSummary, onDownloadLedger }) {
  if (!accountSummary) return null;

  const overdueNum = parseFloat(
    String(accountSummary?.outstandingOver60Days || "0").replace(/,/g, "")
  );
  const isOverdue = !isNaN(overdueNum) && overdueNum > 0;

  return (
    <section className="account-overview">
      <div className="account-overview-header">
        <h2 className="account-overview-title">Account Overview</h2>
        {onDownloadLedger && (
          <button
            className="download-ledger-button"
            onClick={onDownloadLedger}
          >
            <DownloadIcon />
            Download ledger
          </button>
        )}
      </div>
      <div className="account-overview-grid">
        <div className="overview-col">
          <span className="overview-label">Ledger Balance</span>
          <span className="overview-value">
            ₹{accountSummary.currentReceivable || "—"}
          </span>
        </div>
        <div className="overview-col">
          <span className="overview-label">Last Payment</span>
          <span className="overview-value">
            {accountSummary.lastReceiptAmount
              ? `₹${accountSummary.lastReceiptAmount}`
              : "—"}
          </span>
          {accountSummary.lastReceiptDate && (
            <span className="overview-sub">
              on {formatDate(accountSummary.lastReceiptDate)}
            </span>
          )}
        </div>
        <div className="overview-col">
          <span className="overview-label">Overdue &gt;60 Days</span>
          <span
            className={`overview-value${isOverdue ? " overdue-value" : ""}`}
          >
            ₹{accountSummary.outstandingOver60Days || "0"}
          </span>
        </div>
      </div>
    </section>
  );
}

export default AccountOverviewCard;
